import { RoutePermittedRole } from "shared/constants/AppConst";
import MapLoader from "./MapLoader";
import PolygonView from "./polygon";
import MapComponent from "./polygon/PolygonCreate/mapComponent";
import Location from "./location";
import LocationIndex from "./location/LocationCreate";
import DeviceMap from "./device_map/deviceMap";
import PolygonUpdateComponent from "./polygon/PolygonUpdate/PolygonUpdateComponent";
import MapSeeComponent from "./polygonSee/PolygonSee/mapSeeComponent";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const PolygonConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageViewPolygon",
    exact: true,
    element: isModuleAuthorized("Add/Edit Polygon") ||
             isModuleAuthorized("Add Polygon") ||
             isModuleAuthorized("Edit Polygon")
             ? <MapLoader />
             : <Error403 />,
    children: [
      { path: "", element: isModuleAuthorized("Add/Edit Polygon") ? <PolygonView /> : <Error403 /> },
      { path: "Polygon", element: isModuleAuthorized("Add/Edit Polygon") ? <PolygonView /> : <Error403 /> },
      {
        path: "PolygonCreate",
        element: isModuleAuthorized("Add Polygon")
          ? <MapComponent />
          : <Error403 />,
      },
      {
        path: "PolygonUpdate/:id",
        element: isModuleAuthorized("Edit Polygon")
          ? <PolygonUpdateComponent />
          : <Error403 />,
      },
    ],
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageDeviceLocation",
    exact: true,
    element: isModuleAuthorized("View Location") ? <MapLoader /> : <Error403 />,
    children: [
      { path: "", element: isModuleAuthorized("View Location") ? <Location /> : <Error403 /> },
      { path: "location", element: isModuleAuthorized("View Location") ? <Location /> : <Error403 /> },
      { path: "LocationCreate", element: isModuleAuthorized("Create Location") ? <LocationIndex /> : <Error403 /> },
      { path: "LocationCreate/:id", element: isModuleAuthorized("Update Location") ? <LocationIndex /> : <Error403 /> },
    ],
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageViewDeviceMapPolygon",
    exact: true,
    element: isModuleAuthorized("View Device Map") ? <MapLoader /> : <Error403 />,
    children: [
      { path: "", element: isModuleAuthorized("View Device Map") ? <DeviceMap /> : <Error403 /> },
    ],
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageSeePolygon/",
    exact: true,
    element: isModuleAuthorized("Polygon See") ? <MapLoader /> : <Error403 />,
    children: [
      { path: "", element: isModuleAuthorized("Polygon See") ? <MapSeeComponent /> : <Error403 /> },
      { path: "SeePolygon", element: isModuleAuthorized("Polygon See") ? <MapSeeComponent /> : <Error403 /> },
    ],
  },
];
